import { fork } from 'redux-saga/effects';

import { watcher as getTeamReqWatcher } from './get-team-req';

export default function* root() {
  yield fork(getTeamReqWatcher);
}



// WEBPACK FOOTER //
// ./src/redux/teams/root-saga.js